/**
 * 标签管理系统URL配置
 * 根据当前访问的域名自动选择对应的URL
 *
 * 优先级：
 * 1. 环境变量 VUE_APP_TAG_ADMIN_BASE_URL（如果设置了）
 * 2. 根据当前访问的域名判断：
 *    - 如果是生产域名，使用当前 origin 下的 /tag-admin/
 *    - 其他域名使用测试环境URL
 */

// 开发/测试环境URL
const DEVELOPMENT_URL = 'http://172.30.30.75:5000/tag-admin/';

// 同域部署 tag-admin 的生产域名
const PRODUCTION_DOMAINS = [
  'ssz.51gonggui.com',
  'ai.daxiangchelian.com'
];

// 根据当前访问的域名判断使用哪个URL
export const getTagAdminBaseUrl = () => {
  const envUrl = process.env.VUE_APP_TAG_ADMIN_BASE_URL;
  if (envUrl) {
    console.log('[TagAdmin] 使用环境变量 VUE_APP_TAG_ADMIN_BASE_URL 配置的URL:', envUrl);
    return envUrl;
  }

  if (typeof window !== 'undefined' && window.location) {
    const currentHostname = window.location.hostname;
    if (PRODUCTION_DOMAINS.includes(currentHostname)) {
      const url = `${window.location.origin}/tag-admin/`;
      console.log(`[TagAdmin] 生产环境域名 (${currentHostname})，使用同域URL:`, url);
      return url;
    }
  }

  console.log('[TagAdmin] 使用测试环境URL:', DEVELOPMENT_URL);
  return DEVELOPMENT_URL;
};

export const TAG_ADMIN_BASE_URL = getTagAdminBaseUrl();

// 导出配置信息，方便调试
const getCurrentHostname = () => {
  if (typeof window !== 'undefined' && window.location) {
    return window.location.hostname;
  }
  return 'unknown';
};

const currentHostname = getCurrentHostname();
const isProductionDomain = PRODUCTION_DOMAINS.includes(currentHostname);

export const TAG_ADMIN_CONFIG = {
  baseUrl: TAG_ADMIN_BASE_URL,
  hostname: currentHostname,
  isProductionDomain: isProductionDomain,
  productionDomains: PRODUCTION_DOMAINS,
  hasEnvVar: !!process.env.VUE_APP_TAG_ADMIN_BASE_URL,
  env: process.env.NODE_ENV || 'unknown'
};
